// @ts-ignore
import { directive } from 'v-click-outside'

export default directive
